export type Notification = {
  date: string,
  deliveryAddress: string,
  id: string,
  isCurrent: boolean,
  isRead: boolean,
  locationCode: string,
  message: string,
  orderDate: string,
  orderKey: string,
  plantName: string,
  type: NotificationType,
  truckCode: string,
}

export enum NotificationType {
  // for order
  FIRST_LOAD = 'FIRST_LOAD',
  ORDER_BOT_SUCCESS = 'ORDER_BOT_SUCCESS',
  ORDER_BOT_IN_PROCESS = 'ORDER_BOT_IN_PROCESS',
  ORDER_MODIFICATION_PROCESSING = 'ORDER_MODIFICATION_PROCESSING',
  ORDER_MODIFICATION_ACCEPTED = 'ORDER_MODIFICATION_ACCEPTED',
  ORDER_MODIFICATION_ACCEPTED_WITH_CONSULT = 'ORDER_MODIFICATION_ACCEPTED_WITH_CONSULT',
  LAST_LOAD = 'LAST_LOAD',
  LAST_LOAD_WITH_PLUS_LOAD = 'LAST_LOAD_WITH_PLUS_LOAD',

  // for user
  USER_ROLE_UPGRADE = 'USER_ROLE_UPGRADE',
  USER_REMOVE = 'USER_REMOVE',
  USER_ROLE_DOWNGRADE = 'USER_ROLE_DOWNGRADE',

  // for system
  SYSTEM_NOTIFICATION_SETTINGS_AVAILABLE = 'SYSTEM_NOTIFICATION_SETTINGS_AVAILABLE',
}
